/**
 * Layout tokens shared by more than one of `TARSColumnChart`, `TARSBarChart`, `TARSStackedBarChart`.
 * Chart-specific values live next to that chart component.
 */

export const TARS_COLUMN_BAR_CORNER_RADIUS_PX = 12;

export const TARS_AXIS_LABEL_FONT_SIZE_PX = 16;
export const TARS_DATA_LABEL_FONT_SIZE_PX = 18;

export const TARS_CATEGORY_AXIS_LABEL_MAX_WIDTH_PX = 360;
export const TARS_COLUMN_CATEGORY_LABEL_DY_PX = 16;

export const TARS_HORIZONTAL_BAR_LABEL_TO_BAR_GAP_PX = 56;
export const TARS_HORIZONTAL_BAR_LABEL_PADDING_RIGHT_PX = 8;
export const TARS_HORIZONTAL_BAR_VALUE_AXIS_EXTRA_MIN = 0.06;
